import { CheckCircle, RadioButtonUnchecked } from '@mui/icons-material';
import {
	Step,
	StepIconProps,
	StepLabel,
	Stepper,
	Typography,
} from '@mui/material';
import { FC } from 'react';
import { ComplaintDTO } from '../../types/ComplaintDTO';
import { useUtils } from '../../utils/utilFunctions';

function ComplaintStepIcon(props: StepIconProps) {
	const { completed } = props;

	if (completed) {
		return <CheckCircle color="success" />;
	}

	return <RadioButtonUnchecked sx={{ color: 'grey.500' }} />;
}

export const ComplaintTimeline: FC<{complaint: ComplaintDTO}> = ({complaint}) => {
	const { formatStringFullDate } = useUtils();
	const steps = [
		{
			date: complaint.createdAt,
			completedText: 'Denúncia recebida',
			pendingText: 'Aguardando recebimento',
		},
		{
			date: complaint.classificatedAt,
			completedText: 'Classificação definida pelo gestor',
			pendingText: 'Aguardando classificação pelo gestor',
		},
		{
			date: complaint.assignedAt,
			completedText: 'Denúncia atribuída',
			pendingText: 'Aguardando atribuição de ações',
		},
		{
			date: complaint.finishedAt,
			completedText: 'Denúncia finalizada',
			pendingText: 'Aguardando ações do(s) responsável(is)',
		}
	];

	const activeStep = steps.findIndex((step) => step.date === null);
	const finalActiveStep = activeStep === -1 ? steps.length : activeStep;

	return (
		<div className="stepper">
			<Stepper
				activeStep={finalActiveStep}
				orientation="vertical"
			>
				{steps.map((step, index) => {
					if (index > finalActiveStep) return null;
					const isCompleted = index < finalActiveStep;
					return (
						<Step key={step.completedText} completed={isCompleted}>
							<StepLabel StepIconComponent={ComplaintStepIcon}>
								<Typography variant="body1">
									{isCompleted ? step.completedText : step.pendingText}
								</Typography>
								{isCompleted && step.date && (
									<Typography variant="caption" color="text.secondary">{formatStringFullDate(step.date)}</Typography>
								)}
							</StepLabel>
						</Step>
					);
				})}
			</Stepper>
		</div>
	);
};